import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useDocumentCompare } from 'store/document-compare';
import { CompareFileItem } from './components/compare-file-item';

const SContainer = styled.div`
    position: fixed;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 90;
    height: 48px;
    display: flex;
    align-items: center;
    border-radius: 24px;
    max-width: 90%;
    padding: 8px;
    border-radius: 12px;
    background-color: ${({ theme }) => theme.colors.athens_gray};
    border: 1px solid ${({ theme }) => theme.colors.iron};
    box-shadow: 0px 4px 32px -4px #00000008;
`;

const SFileInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
`;

const STextWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 0 142px;
`;

const SSpan = styled.span`
    font-size: ${({ theme }) => theme.font.size.medium};
    font-weight: ${({ theme }) => theme.font.weight.medium};
`;

export const CompareModeIsland = () => {
    const { t } = useTranslation();
    const { isInCompareMode, firstFile, secondFile, setFirstFile, setSecondFile } =
        useDocumentCompare();

    if (!isInCompareMode) {
        return null;
    }

    const handleRemoveFirstFile = () => {
        setFirstFile(null);
    };

    const handleRemoveSecondFile = () => {
        setSecondFile(null);
    };

    return (
        <SContainer>
            <SFileInfo>
                {!firstFile && !secondFile ? (
                    <STextWrapper>
                        <SSpan>{t('compare-mode.no-selected-files')}</SSpan>
                    </STextWrapper>
                ) : (
                    <>
                        <CompareFileItem
                            file={firstFile}
                            label={`${t('compare-mode.first-file')}:`}
                            onRemove={handleRemoveFirstFile}
                        />
                        <CompareFileItem
                            file={secondFile}
                            label={`${t('compare-mode.second-file')}:`}
                            onRemove={handleRemoveSecondFile}
                        />
                    </>
                )}
            </SFileInfo>
        </SContainer>
    );
};
